import { render, staticRenderFns } from "./Inventory.vue?vue&type=template&id=0fbb08b2&"
import script from "./Inventory.vue?vue&type=script&lang=ts&"
export * from "./Inventory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports